export var defaultCurrencies = [{
  code: 'RUB',
  label: 'Рубль'
}, {
  code: 'USD',
  label: 'Доллар'
}, {
  code: 'EUR',
  label: 'Евро'
}, {
  code: 'CNY',
  label: 'Юань'
}];
export var additionalCurrencies = [{
  code: 'AMD',
  label: 'Драм'
}, {
  code: 'BGN',
  label: 'Лев'
}, {
  code: 'BRL',
  label: 'Реал'
}, {
  code: 'GBP',
  label: 'Фунт'
}, {
  code: 'KZT',
  label: 'Тенге'
}, {
  code: 'MDL',
  label: 'Лей'
}, {
  code: 'UAH',
  label: 'Гривна'
}, {
  code: 'JPY',
  label: 'Иена'
}, {
  code: 'KRW',
  label: 'Вона'
}, {
  code: 'TJS',
  label: 'Сомони'
}];
export var defaultCurrenciesCodes = defaultCurrencies.map(function (item) {
  return item.code;
});
var additionalCurrenciesCodes = additionalCurrencies.map(function (item) {
  return item.code;
});
export var currencyCodes = defaultCurrenciesCodes.concat(additionalCurrenciesCodes);